/* eslint-disable vue/require-v-for-key */
<template>
  <v-card>
    <v-form ref="form" v-model="isFormValid" lazy-validation>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="selectedItem.name"
                label="Nome da Taxa"
                required
                :rules="formRules.nameRules"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
        <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-select
                v-model="selectedItem.type"
                :items="itemsType"
                item-text="type"
                item-value="value"
                label="Tipo"
                :rules="formRules.typeType"
                persistent-hint
                return-object
                single-line
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                v-model="selectedItem.fixed_value"
                label="Valor Fixo"
                required
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <v-text-field
                v-model="selectedItem.factor_value"
                label="Fator"
                required
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          
        
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#0dc4b8" text @click="$emit('onClose')"> Cancelar </v-btn>
        <v-btn
          color="#0dc4b8"
          text
          @click="submit"
          :disabled="isLoading"
          :loading="isLoading"
        >
          {{ formButtonText }}
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>


<script>
import { mapMutations } from "vuex";
//import RegistrationService from "../../services/registrationArea.service";
import Api from "../../services/api.service";

export default {
  name: "FeeForm",
  props: {
    selectedIndex: {
      type: Number,
      required: false,
      default: -1,
    },
    selectedData: Array,
    filesRegistrationsProps: Array,
    filesAreasProps: Array,
    selectedActive: Array,
  },
  data: () => ({
    formRules: {
      nameRules: [(v) => !!v || "Nome da Taxa é obrigatória"],
      typeType: [(v) => !!v || "Tipo da Taxa é obrigatório"],
      initialRules1: [(v) => !!v || "Token Inicial é obrigatório"],
      finalRules1: [(v) => !!v || "Token Final é obrigatório"],
      initialRules2: [(v) => !!v || "Token Inicial é obrigatório"],
      finalRules2: [(v) => !!v || "Token Final é obrigatório"],
      registrationRules: [
        (v) =>
          !!v || v.size < 2000000 || "Documento deve ser menor do que 2 MB!",
      ],
      areaRules: [
        (v) => !!v || v.size < 2000000 || "Foto deve ser menor do que 2 MB!",
      ],
    },
    isFormValid: true,
    isLoading: false,
    selectedItem: {
      name: null,
      type: null,
      fixed_value: null,
      factor_value: null,
    },
    itemsType:[
      {type: "Ativos", value: "Ativos"},
      {type: "Criptos", value: "Criptos"},
    ],
  }),
  computed: {
    formButtonText() {
      return this.selectedIndex === -1 ? "Criar" : "Editar";
    },
  },
  mounted() {
    this.loadCreated();

    if (this.selectedIndex !== -1) {
      setTimeout(() => {
        this.selectedItem.name = this.selectedData.name;
        this.selectedItem.type = this.selectedData.type;
        this.selectedItem.fixed_value = this.selectedData.fixed_value;
        this.selectedItem.factor_value = this.selectedData.factor_value;
      }, 10);
    }
  },
  methods: {
    ...mapMutations(["showSnackbar"]),

    openDialog() {
      this.dialog = true;
    },

    closeDialog() {
      // this.closeFormModal();

      this.selectedItem.name = null;
      this.selectedItem.type = null;
      this.selectedItem.fixed_value = null;
      this.selectedItem.factor_value = null;
      this.$emit("onClose");
    },

    async loadCreated() {
      Api.get("fee/create").then((res) => {
        this.fee = res.data[0];
      });
    },

    changeLotes(obj) {
      Api.get(`generation-tokens/${obj.id}`)
        .then((res) => {
          res.data.lotes.map((item) => {
            this.lotes.push(item.lote);
          });
        })
        .catch(() => {
          this.showSnackbar({
            text: "Ops!, Houve um erro ao carregar os Lotes, tente novamente mais tarde.",
            color: "error",
          });
        });
    },

    async submit() {
      this.isLoading = true;
      if (this.selectedIndex === -1) {
        let data = new FormData();
        data.append("name", this.selectedItem.name);
        data.append("type", this.selectedItem.type);
        data.append("fixed_value", this.selectedItem.fixed_value);
        data.append("factor_value", this.selectedItem.factor_value);
        
        Api.post("fee", data, {
          header: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then(() => {
            this.showSnackbar({
              text: "Cadastrado! Taxa de Operação cadastrada com sucesso.",
              color: "success",
            });

            this.isLoading = false;
            this.closeDialog();
          })
          .catch(() => {
            this.showSnackbar({
              text: "Ops! Houve um erro, tente novamente.",
              color: "error",
            });

            this.isLoading = false;
          });
      } else {
        let data = new FormData();

        data.append("name", this.selectedItem.nameRegistration);
        data.append("type", this.selectedItem.type);
        data.append("fixed_value", this.selectedItem.fixed_value);
        data.append("factor_value", this.selectedItem.factor_value);

        Api.patch(`fee/${this.selectedIndex}`, data, {
          header: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then(() => {
            this.showSnackbar({
              text: "Cadastrado! Taxa de Operação cadastrada com sucesso.",
              color: "success",
            });

            this.isLoading = false;
            this.closeDialog();
          })
          .catch(() => {
            this.showSnackbar({
              text: "Ops! Houve um erro, tente novamente.",
              color: "error",
            });

            this.isLoading = false;
          });
      }
    },
  },
};
</script>
